import {combineReducers} from 'redux';
import {showLoaderSlice, ShowLoaderState} from './showLoader';
import {LoaderTextState, loaderTextSlice} from './loaderText';

export type LoaderState = {
  loaderText: LoaderTextState;
  showLoader: ShowLoaderState;
};

export const loader = combineReducers({
  loaderText: loaderTextSlice.reducer,
  showLoader: showLoaderSlice.reducer,
});
